export default "__VITE_ASSET__CCL9tzGB__"